module.exports = __webpack_public_path__ + "img/primevue.53c23fb.jpg";